import { createFileRoute } from '@tanstack/react-router'

import { MenuManagement } from '#components/features/products/menu-management'
import { MenuSectionNavigation } from '#components/features/products/menu-section-navigation'
import { PageHeader } from '#components/layout/page-header'

export const Route = createFileRoute('/_auth/_admin/cardapio/categorias')({
  head: () => ({
    meta: [
      { title: 'Categorias do cardápio | UseComanda' },
      {
        name: 'description',
        content: 'Organize categorias, tamanhos e regras de preparo.',
      },
    ],
  }),
  component: CategoriesPage,
})

function CategoriesPage() {
  return (
    <main className="bg-muted/20 min-h-full px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl space-y-6">
        <PageHeader
          eyebrow="Cardápio"
          title="Cardápio"
          subtitle="Organize os grupos de produtos, tamanhos e regras de preparo."
        />
        <MenuSectionNavigation />
        <MenuManagement view="categories" />
      </div>
    </main>
  )
}
